import axios from "axios";
import Alert from "react-s-alert";
import {
  ALL_CATEGORY,
  GET_ALL_CATEGORY,
  SET_LOADER_SECONDARY,
  CLEAR_LOADER,
  // SET_CURRENT_USER,
  // SET_CURRENT_USER_DECODED_TOKEN,
  // LOG_OUT,
  // SET_RESTAURANT_DETAILS,
  // ACCESSIBILITY_TYPE,
  // DRESS_CODE_TYPE,
  // PARKING_TYPE,
  // PAYMENT_METHOD_TYPE,
  // PET_ALLOWANCE_TYPE,
  // RESTAURANT_TYPE,
  // RESTAURANT_CHAIN,
  // RESTAURANT_FEATURES,
  CLEAR_ERRORS,
  // LOCATED_INSIDE,
  // HEALTH_ENTRY_POINT,
  // HEALTH_INSIDE_FACILITY,
  // HEALTH_EMPLOYEES,
  // HEALTH_FOOD_HANDLE,
  // HEALTH_AND_SAFETY,
  // OTHER_FEATURES,
  // SERVICES_OFFERED,
  FOOD_TYPE,
  // LIQUORS,
  // FOOD_CATEGORY,
  // CUISINES,
  // SEATING_AREA,
} from "../types";

import { setErrors } from "../actions/errorActions";
import { serverApi } from "../../config/Keys";
import { amApi } from "../../api/apiHelper";

export const get_all_category = () => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_ERRORS });
    let { data } = await axios.get(`${serverApi}/category`);
    dispatch({
      type: ALL_CATEGORY,
      payload: data.data,
    });
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const get_all_categories = (onSuccess) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  try {
    let get_all_categories = await axios.get(`${serverApi}/category`);
    if (get_all_categories.data) {
      dispatch({
        type: GET_ALL_CATEGORY,
        payload: get_all_categories.data,
      });
    }
    onSuccess(get_all_categories.data);
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const create_sub_category =
  (formData, callback, onErrorCallback) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      let add_sub_category = await axios.post(
        `${serverApi}/subcategory`,
        formData
      );
      if (add_sub_category.status === 201) {
        Alert.success(
          `<h4>Your Suggestion Successfully Send To Super Admin</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
        callback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onErrorCallback(err);
    }
  };

const ALL_CATEOGORY_KEYS = {
  RESTAURANT_TYPE: "5f562c9094ac7fdf47ea1d0a",
  ACCESSIBILITY_TYPE: "5f562c9094ac7fdf47ea1d17",
  DRESS_CODE_TYPE: "5f562c9094ac7fdf47ea1d0c",
  PARKING_TYPE: "5f562c9094ac7fdf47ea1d15",
  PAYMENT_METHOD_TYPE: "5f562c9094ac7fdf47ea1d0b",
  PET_ALLOWANCE_TYPE: "5f562c9094ac7fdf47ea1d0d",
  RESTAURANT_FEATURES: "5f562c9094ac7fdf47ea1d18",
  LOCATED_INSIDE: "5f562c9094ac7fdf47ea1d0e",
  POINT_OF_SALE: "5fa2abe7a930bc32ce5790c7",
  HEALTH_ENTRY_POINT: "5f562c9094ac7fdf47ea1d10",
  HEALTH_INSIDE_FACILITY: "5f562c9094ac7fdf47ea1d11",
  HEALTH_EMPLOYEES: "5f562c9094ac7fdf47ea1d12",
  HEALTH_FOOD_HANDLE: "5f562c9094ac7fdf47ea1d13",
  HEALTH_AND_SAFETY: "5f562c9094ac7fdf47ea1d14",
  OTHER_FEATURES: "5f562c9094ac7fdf47ea1d18",
  SERVICES_OFFERED: "5f562c9094ac7fdf47ea1d19",
  FOOD_CATEGORY: "5f562c9094ac7fdf47ea1d1b",
  FOOD_TYPE: "5f562c9094ac7fdf47ea1d1d",
  LIQUORS: "5f562c9094ac7fdf47ea1d1c",
  CUISINES: "5f562c9094ac7fdf47ea1d1e",
  SEATING_AREA: "5f5723f455e36968b805b4cb",
  ALLERGY_INFORMATION: "5f59f5d4471b85440d5adccc",
  TAGS_INFORMATION: "5ffd80985ff032513b1353a2",
  UOM_INFORMATION: "60546a549e335e3e567c74ce",
  BEVERAGES_TYPE:
    serverApi === "https://devapi.amealio.in"
      ? "610ae22075b5b5765e52bcc5"
      : "610adf858f96441ed7026a11",
  CATEGORY_CLASSIFICATION: "6180fac9cbfc825a0db877c4",
  MAJOR_CLASSIFICATION: "62033b93e126cc2339e94652",
  HEALTH_TAGS: "6204d2c756deb559e7df52b5",
};

export const get_all_subcategory = () => async (dispatch) => {
  try {
    let allCategoryData = await amApi.post(`filterData`, ALL_CATEOGORY_KEYS);
    if (allCategoryData.status === 201) {
      allCategoryData = allCategoryData.data;
    }
    Object.keys(allCategoryData).forEach((key, index) => {
      dispatch({
        type: key,
        payload: allCategoryData[key],
      });
    });
  } catch (err) {
    dispatch(setErrors(err));
  }
};

// export const get_all_subcategory = () => async (dispatch) => {
//   try {
//     dispatch({ type: CLEAR_ERRORS });
//     let all_promise = [];
//     let all_category_keys = Object.keys(ALL_CATEOGORY_KEYS);
//     all_category_keys.forEach((element) => {
//       all_promise.push(
//         axios.get(
//           `${serverApi}/subcategory?category_id=${ALL_CATEOGORY_KEYS[element]}`
//         )
//       );
//     });
//     Promise.all(all_promise)
//       .then((data) => {
//         let responseData = data.map((elem) => elem.data);
//         // console.log(responseData);
//         all_category_keys.forEach((key, index) => {
//           dispatch({
//             type: key,
//             payload: responseData[index],
//           });
//         });
//         dispatch({
//           type: "FETCH_FLAG",
//           payload: true,
//         });
//       })
//       .catch((err) => console.log(err));
//   } catch (err) {
//     dispatch({ type: CLEAR_LOADER });
//     dispatch(setErrors(err));
//   }
// };

export const get_single_subcategory =
  (catId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    try {
      let get_single_subcategory = await axios.get(
        `${serverApi}/subcategory?category_id=${catId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (get_single_subcategory.status === 200) {
        dispatch({
          type: FOOD_TYPE,
          payload: get_single_subcategory.data,
        });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
